export default {
  id: "string",
  name: "string",
  event: "string"
}



// WEBPACK FOOTER //
// ./src/store/models/screen.js